module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAM1BMVEUAAAAnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrb///9dZuxRAAAAD3RSTlMAJPTvjU/Mt64zMOXIjkjVDP+fAAAAbElEQVQY022RWw6AIAwEVwooD6n3P62RhqC48zlpm7YLI/taXKk+Y7IdOji2IZvoRJrJoF9Cb3eLdc+QXVd2IOmfhJNYj0psRCFWoMZlqAEhVhDZXL4D35ffxv/Af9a1e1cGnsUk+ygqceR2A9GTE507n706AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_cancel_active.png
// module id = SXy8
// module chunks = 9